export default __webpack_public_path__ + "static/NMN-logo-white-text-c5508da9fdf6cc2ec7bb55a07add2cee.svg";